import React, { useState, useEffect,useRef, useLayoutEffect } from 'react';
import {Main,Axios,Loading,usePaginacion,Paginacion} from '../../../Helpers/importacionesComunes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf,faWindowClose,faFileExcel,faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import {useContextoGlobal} from '../../../Context/contextoGlobal';
import DatePicker from "react-datepicker";
import BusquedaSinForm from '../../../componentes/BusquedaSinForm';
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import Swal from 'sweetalert2';
import es from 'date-fns/locale/es';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import {formatearMontoMoneda} from '../../../Helpers/utilidades-globales'
import { useHistory } from "react-router-dom";
import { TrashIcon, PlusIcon } from '@heroicons/react/24/outline';
import { ArrowDownTrayIcon } from "@heroicons/react/24/solid";
import { PaperAirplaneIcon } from "@heroicons/react/24/solid";
import { PrinterIcon } from "@heroicons/react/24/solid";
import { CheckIcon } from "@heroicons/react/24/solid";
import { XCircleIcon } from "@heroicons/react/24/solid";
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import {getToken} from '../../../Helpers/auth-helpers';
import {formatearComparacion,formatoMoneda,hacerfocoEnPrimerInput,seleccionarTextoInput,capitalizarNombre} from '../../../Helpers/utilidades-globales';
import SelectorObreroTypeahead from '../../../componentes/SelectorObreroTypeahead';
import {transformarIso8601,obtenerFechaDiamenosN,obtenerFechaUltimoDiaMes} from '../../../Helpers/fechas';
import ReportesEgresosIntegrados from '../../../reportes/ReportesEgresosIntegrados';
import ImpresionPDF from '../../../componentes/ImpresionPDF';
import { 
    Button, 
    Card, 
    Checkbox, 
    Input, 
    Option, 
    Select, 
    Spinner, 
    Typography, 
    Tabs, 
    Tab,
    TabPanel,
    TabsHeader, 
    TabsBody,
    Switch,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter
} from '@material-tailwind/react';
import { convertirMesAñoAfechaCompleta } from '../../ReporteIngresosIntegrales';
import { Tabla } from '../componentes/Tabla';
import { TablaMobile } from '../componentes/TablaMobile';
import { ImprimirDetalleEgreso } from '../../../impresiones/detalle-egreso';
import DepositoPrecargado from './DepositoPrecargado';
import { useIngresos } from '../hooks/useIngresos';
import {detallePagosEx,formaPagosEx,paramsEx,formaPagosDiezmoPersonalEx,detallePagosDiezmoPersonalEx,formaPagosDiezmoIglesiaEx,detallePagosDiezmoIglesiaEx} from './ejemplo';

const initParams = {
    id_tanda:103,
    tipo: 'tipo-rg',
    id_año_fiscal:null,
    mesAño:null,
    año:null,
    id_obrero: null,
    criterio:'',
    destino: 'pastor',
    nombre_destino:'',
    id_obrero:null,
    isexterno: false,
    id_iglesia:null,
    id_proveedor:null,    
    id_provincia: null,  
    id_region: null,
    id_fondo_tesoreria: null,
    usuario_alta: null,   
    tipo_recibo: 1,                                       
    formapago:null,
    rubro:null,
    fondo:null,
    moneda:1,
    caja:null,
    monto: 0,
    fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
    fechaHasta:new Date(),
    fecha:new Date(),
    descripcion:'',
    total_caja:false,
    total_diario:false,
    total_mensual:false,
    fdo_regiones: false,
    tipo_formapago: null,
    formapago: null,
    hiddenCols: [],
    total_año:false,
    nro_desde: null,
    nro_hasta: null,
    orden: null,
    no_agrupar:false
}

export default function CreaEditarIngreso(){
    const [cargandoRegistros,setCargandoRegistros] = useState(false);
    const [IsFetchingData, setIsFetchingData] = useState(false);
    const [isSendingMail, setIsSendingMail] = useState(false);
    const [huboError,setHuboError] = useState(false);
    const [datos,setDatos] = useState([]);
    const { esCelular, usuario } = useContextoGlobal();
    const [textoBusqueda,setTextoBusqueda] = useState('');
    const [contadorConsulta,setContadorConsulta]=useState(0);   
    const [parametros,setParametros]=useState(initParams)
    const [formaPagos,setFormaPagos]=useState([]);
    const [detallePagos, setDetallePagos] = useState([]);
    const [openFPago,setOpenFPago] = useState(false);
    const [openDetallePagos,setOpenDetallePagos] = useState(false); // modal detalle
    const [rubrosDetalle,setRubrosDetalle] = useState([]); // rubros habilitados para detalle pago (según obrero)
    const [iglesiasDetalle,setIglesiasDetalle] = useState([]); // iglesias filtradas para diezmos
    const [provincias,setProvincias] = useState([]);
    const [periodosFiscales,setPeriodosFiscales] = useState([]);
    const [tandas,setTandas] = useState([]);
    const [rubros,setRubros] = useState([]);
    const [monedas,setMonedas] = useState([]);
    const [cajas,setCajas] = useState([]);
    const [fondos,setFondos] = useState([]);
    const [formasPago,setFormasPago] = useState([]);
    const [obreros,setObreros] = useState([]);
    const [backUpObreros,setBackUpObreros] = useState([]);
    const [bancos,setBancos] = useState([]);
    const [iglesias,setIglesias] = useState([]);
    const [tiposMovBanco,setTiposMovBanco] = useState([]);
    const [terminalesUsers,setTerminalesUsers] = useState([]);
    const [listaIglesiasDiezmo, setListaIglesiasDiezmo] = useState([]);
    const [regiones,setRegiones] = useState([]);
    const [bancoCuentas, setBancoCuentas] = useState([]);
    const [tipoRecibos,setTipoRecibos] = useState([]);
    const [comprEgresos,setComprEgresos] = useState([]);
    const [proveedores, setProveedores] = useState([]);
    const [activeTab, setActiveTab] = useState('datosE');
    const [isFormasPagoEdit, setIsFormasPagoEdit] = useState(false);
    const [isDetalleEdit, setIsDetalleEdit] = useState(false);
    const [id_ingreso, setIdIngreso] = useState(null);
    const [numeroInterdeposito, setNumeroInterdeposito] = useState(null);
    const [reporteEnEjecucion,setReporteEnEjecucion] = useState(false)
    const meses = [0,1,2,3,4,5,6,7,8,9,10,11,12];
    const {configuracion,paginar,inicializar} = usePaginacion();
    const history = useHistory();
    const nombreCriterio = useRef('Seleccione el año fiscal:')
    const {imprimirRecibo,
        enviarMailRecibo,
        descargarRecibo,
        eliminarIngreso,
        anularIngreso} = useIngresos(setIsSendingMail)
    registerLocale('es', es)


    const subtitulo = useRef('');

    useEffect(()=>{
        buscarTablasGenerales()
        if (localStorage.getItem('editIngresoId')) {
            const ingresoDetalle = JSON.parse(localStorage.getItem('editIngresoId'));
            setIdIngreso(ingresoDetalle.id_ingreso);
            buscarIngresoInfo(ingresoDetalle.id_ingreso);
            localStorage.removeItem('editIngresoId');
        } else {
            setParametros(prev => ({...prev,tipo_recibo:'C', usuario_alta: usuario?.nombre || ''}));
        }
        dispararJobIngresos('reset'); // si existe un job activo para actualizar la base de ingresos se reinicia el contador del tiempo.
    },[])

    useEffect(()=>{
        if (parametros.id_obrero && parametros.tipo_recibo) buscarRubrosPorObrero();
    },[parametros.id_obrero, parametros.tipo_recibo])

    useEffect(()=>{
        if (formasPago.length > 0) setIsFormasPagoEdit(true);
    },[formasPago])

    useEffect(()=>{
        if (detallePagos.length > 0) setIsDetalleEdit(true);
    },[detallePagos])

      const buscarTablasGenerales = async ()=>{
        try{
            setCargandoRegistros(true)
            const vectorResultados = await Promise.all([Axios.get('/api/tablasgenerales/reportes/tandas'),
            Axios.get('/api/tablasgenerales/reportes/perfiscales'),
            Axios.get('/api/tablasgenerales/rubrosingresos'),
            Axios.get('/api/reportes/tablas/monedas'),
            Axios.get('/api/reportes/tablas/cajas'),
            Axios.get('/api/reportes/tablas/fondos'),
            Axios.get('/api/tablasgenerales/provincias'),
            Axios.get('/api/tablasgenerales/terminales-usuarios'),
            Axios.get('/api/tablasgenerales/tipo-recibos'),
            Axios.get('/api/tablasgenerales/regiones'),
            Axios.get('/api/tablasgenerales/obreros'),
            Axios.get(`/api/tablasgenerales/bancos`),
            Axios.get('/api/tablasgenerales/tipo-mov-bancos/lista'),
            Axios.get('/api/tablasgenerales/banco/cuentas'),
            Axios.get('/api/tablasgenerales/obtener/numero/interdeposito')
            ])
            setTandas(vectorResultados[0].data)
            setPeriodosFiscales(vectorResultados[1].data.reverse())
            setRubros(vectorResultados[2].data)
            setMonedas(vectorResultados[3].data)
            setCajas(vectorResultados[4].data)
            setFondos(vectorResultados[5].data)
            setProvincias(vectorResultados[6].data)
            setTerminalesUsers(vectorResultados[7].data)
            setTipoRecibos(vectorResultados[8].data)
            setRegiones(vectorResultados[9].data)
            setObreros(vectorResultados[10].data)
            setBackUpObreros(vectorResultados[10].data)
            setBancos(vectorResultados[11].data.recordsets[0])
            setTiposMovBanco(vectorResultados[12].data)
            setBancoCuentas(vectorResultados[13].data)
            setNumeroInterdeposito(vectorResultados[14].data[0].id_tipo_mov_banco)
            setCargandoRegistros(false)
        }catch(err){
            setCargandoRegistros(false)
            setHuboError(true)
            console.log('Error al buscar los datos generales')  
        }
    }

    const buscarIngresoInfo = async (id_ingreso) => { 
        try{
            setCargandoRegistros(true)
            const vectorResultados = await Promise.all([
                Axios.get('/api/tablasgenerales/ingresos/detalle/'+id_ingreso),
                Axios.get('/api/tablasgenerales/ingresos/pagos/cargar/'+id_ingreso),
                Axios.get('/api/tablasgenerales/ingresos/detalle/pagos/libro/'+id_ingreso),
                Axios.get('/api/tablasgenerales/ingresos/detalle/cargar/'+id_ingreso),
            ])
            const ingreso = vectorResultados[0].data;
            const pagos = vectorResultados[1].data;
            const libro = vectorResultados[2].data;
            const detalles = vectorResultados[3].data;

            setParametros({
                ...parametros,
                fecha: ingreso[0].fecha,
                usuario_alta: ingreso[0].usuario_alta,
                id_ingreso: ingreso[0].id_ingreso,
                id_tanda: ingreso[0].id_tanda,
                id_rubro: ingreso[0].id_rubro,
                id_obrero: ingreso[0].id_obrero,
                id_iglesia: ingreso[0].id_iglesia,
                id_tipo_comp_egr: ingreso[0].id_tipo_comp_egr,
                monto: detalles.reduce((acc, curr) => acc + Number(curr.monto), 0),
                tipo_recibo: ingreso[0].tipo_compr,
                nro_comprobante: ingreso[0].nro_comprobante,
                descripcion: ingreso[0].descripcion
            })

            setFormaPagos(pagos.map((pago) => {
                const foundLib = libro.find(lib => Number(pago.cod_op_lib_banco ?? 0) === Number(lib.cod_op_lib_banco));
                return {
                    cod_op_ingr_pago: pago.cod_op_ingr_pago,
                    cod_op_lib_banco: pago.cod_op_lib_banco,
                    f_pago: pago.forma_pago,
                    m_bruto: pago.monto_bruto,
                    v_cambio_pesos: pago.valor_cambio,
                    m_neto: pago.neto_pesos,
                    tipo_movimiento: foundLib?.id_tipo_mov_banco,
                    n_comprobante: foundLib?.numero_comprobante,
                    f_emision: foundLib?.f_alta ? moment(foundLib.f_alta).format('DD-MM-YYYY HH:mm') : null,
                    f_acreditacion: foundLib?.fecha_acreditacion ? moment(foundLib?.fecha_acreditacion).format('DD-MM-YYYY HH:mm') : null,
                    id_banco: foundLib?.id_libro_banco
                }
            }));

            console.log("detalles", detalles);
            setDetallePagos(detalles.map((det) => ({
                detalle: det.detalle,
                periodo: det.periodo,
                id_iglesia: det.id_iglesia,
                iglesia: det.iglesia,
                cod_op_ingr_det: det.cod_op_ingr_det,
                monto: Number(det.monto),
                isNew: true
            })));

            setCargandoRegistros(false)
        }catch(err){
            setCargandoRegistros(false)
            setHuboError(true)
            console.log('Error al buscar los datos generales')  
        }
    }

    const copiarEjemplo = (tipo)=>{

        const fechaId = new Date().toLocaleString('es-AR', { hour12: false });

        const min = 10000;
        const max = 20000;
        const monto = Math.floor(Math.random() * (max - min + 1)) + min;

        setParametros({...parametros,...JSON.parse(JSON.stringify(paramsEx)),descripcion:fechaId,monto:monto})
        
        switch (tipo){
            case 'fondo_x':
                setFormaPagos([...formaPagosEx.map(i=>{
                    return {...i,m_neto:monto,m_bruto:monto}
                })])
                setDetallePagos([...detallePagosEx.map(i=>{
                    return {...i,monto:monto}
                })]);
                break;

            case 'diezmo_personal':
                setFormaPagos([...formaPagosDiezmoPersonalEx.map(i=>{
                    return {...i,m_neto:monto,m_bruto:monto}
                })])
                setDetallePagos([...detallePagosDiezmoPersonalEx.map(i=>{
                    return {...i,monto:monto}
                })]);
                break;
            case 'diezmo_iglesia':
                setFormaPagos([...formaPagosDiezmoIglesiaEx.map(i=>{
                    return {...i,m_neto:monto,m_bruto:monto}
                })])
                setDetallePagos([...detallePagosDiezmoIglesiaEx.map(i=>{
                    return {...i,monto:monto}
                })]);
                break;
            default :
                setFormaPagos([...formaPagosEx.map(i=>{
                    return {...i,m_neto:monto,m_bruto:monto}
                })])
                setDetallePagos([...detallePagosEx.map(i=>{
                    return {...i,monto:monto}
                })]);
                break;
        }


    }

    const goToEgresoList = ()=>{
        history.push('/ingresos-t')
    }

    const buscarIglesiasPorObrero = async (e)=>{
        const id_obrero = e.target.value;
        setParametros({...parametros, id_obrero, id_iglesia: null});
        try{
            if (!id_obrero) {
                setIglesias([]);
                setRubrosDetalle([]);
                return;
            }
            const iglesias = await Axios.get('/api/tablasgenerales/iglesiasobrero/'+id_obrero)
            setIglesias(iglesias.data)
        }catch(err){
            console.log('Error al buscar los datos generales')  
        }
    }

    const buscarRubrosPorObrero = async (e)=>{
        try{
            console.log(parametros);
            const respRub = await Axios.get(`/api/tablasgenerales/rubrosingresos-recibo/${parametros.id_obrero}/${parametros.tipo_recibo}`); // tipo_rc fijo 'ingreso' (ajustar si difiere)
            setRubrosDetalle(respRub.data || []);
        }catch(err){
            console.log('Error al buscar los datos generales')  
            setRubrosDetalle([]);
        }
    }

    const iniciarGrabarIngreso = () => {
        Swal.fire({
            text: 'Está seguro de guardar los cambios?',
            showCancelButton: true,
            confirButtonText: 'Guardar',
            cancelButtonText: 'Cancelar'
        }).then(
            resultado => {
                if (resultado.value) {
                  grabarIngreso();
                } else console.log("Se canceló la creación de un nuevo ingreso")
            }
        )
    }

    const cleanUpFormaPago = (index) => { 
        Swal.fire({
            text: '¿Está seguro de eliminar ésta forma de pago?',
            showCancelButton: true,
            confirButtonText: 'Guardar',
            cancelButtonText: 'Cancelar'
        }).then(
            resultado => {
                if (resultado.value) {
                    const newFormaPagos = formaPagos.filter((_, i) => i !== index);
                    setFormaPagos(newFormaPagos);
                } else console.log("Se canceló la eliminación de la forma de pago")
            }
        )
    }

    const cleanUpDetallePago = (code, monto) => { 
        Swal.fire({
            text: '¿Está seguro de eliminar éste detalle de pago?',
            showCancelButton: true,
            confirButtonText: 'Guardar',
            cancelButtonText: 'Cancelar'
        }).then(
            resultado => {
                if (resultado.value) {
                    const newDetallesPago = detallePagos.filter(item => item.cod_op_ingr_det !== code);
                    setDetallePagos(newDetallesPago);
                    setParametros(p => ({ ...p, monto: Number(p.monto) - monto }));
                } else console.log("Se canceló la eliminación del detalle de pago")
            }
        )
    }

    const grabarIngreso = async () => {
        setIsFetchingData(true);
        try { 
            let dataSubmit = {
                id_ingreso,
                fecha: moment(convertirMesAñoAfechaCompleta(parametros.fecha), 'YYYY-MM-DD').set({ hour: moment().hour(), minute: moment().minute(), second: moment().second() }).format('YYYY-MM-DD HH:mm:ss'),
                id_obrero: parametros.id_obrero ? Number(parametros.id_obrero) : null,
                id_iglesia: parametros.id_iglesia ? Number(parametros.id_iglesia) : null,
                descripcion: parametros.descripcion,
                tipo_compr: parametros.tipo_recibo,
                nro_comprobante_manual: parametros.nro_comprobante,
                monto: parametros.monto,
                formaPagos: formaPagos,
                detalles: detallePagos
            };

            const response = await Axios.post('/api/tablasgenerales/ingresos/grabar', dataSubmit);
            setIsFetchingData(false);     
            if (!id_ingreso) {
                const nroRecibo = response.data?.[0]?.nro_comprobante || response.data?.nro_comprobante || parametros.nro_comprobante || 'Cxxxx';
                const id_ingreso_new = response.data?.[0]?.id_ingreso;

                const resultMail = await Swal.fire({
                    title: `Ingreso guardado con éxito (Id interno ${id_ingreso_new})`,
                    text: `¿Desea enviar el recibo por mail?`,
                    icon: 'success',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, enviar',
                    cancelButtonText: 'No'
                });

                if (resultMail.isConfirmed) {
                    // Lógica para enviar por mail
                    await enviarMailRecibo(id_ingreso_new);
                }

                const resultPrint = await Swal.fire({
                    title: 'Imprimir recibo',
                    text: `¿Desea imprimir el recibo ${nroRecibo}?`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, imprimir',
                    cancelButtonText: 'No'
                });

                if (resultPrint.isConfirmed) {
                    // Lógica para imprimir
                    await imprimirRecibo(id_ingreso_new);
                }

                history.push('/ingresos-t');
            } else {
                Swal.fire(`Ingreso guardado con éxito`,'','info');
                history.push('/ingresos-t');
            }

            await dispararJobIngresos('set') // Activa un job que se va a ejecutar en 3 minutos para actualizar la base de ingresos. Si existe el job activo se reinicia el tiempo, si no existe lo activa.

        } catch (error) {
            console.log('Error al ejecutar la búsqueda', error);
            setIsFetchingData(false);
            Swal.fire(`No se pudo guardar el nuevo ingreso`,'','error')
        }
    }

    const dispararJobIngresos = async (operacion)=>{
        try{
                const {data}= await Axios.get(`/api/utilidades/triggerjob/ingresos/${usuario.nombre}/${operacion}`)
                console.log(data)
            }catch(err){
                console.log(err.response.data)
        }    
    }

    const impDetallEgreso = async () => { 
        
        const newData = {
            ...parametros,
            proveedor: proveedores.find(prov => prov.id_proveedor === parametros.id_proveedor)?.nombre,
            caja: cajas.find(caja => caja.id_caja === parametros.id_caja)?.nombre,
            tanda: tandas.find(tanda => tanda.id_tanda === parametros.id_tanda)?.nombre,
            rubro: rubros.find(rubro => rubro.id_rubro === parametros.id_rubro)?.nombre,
            moneda: monedas.find(moneda => moneda.id_tipo_moneda === parametros.id_tipo_moneda)?.nombre,
            comporbante_egreso: comprEgresos.find(compr => compr.id_tipo_comp_egr === parametros.id_tipo_comp_egr)?.nombre,
            formaPagos: parametros.formaPagos.map((formaPago) => ({
                ...formaPago,
                tipo_movimiento: tiposMovBanco.find(tipo => tipo.id_tipo_mov_banco === formaPago.tipo_movimiento)?.nombre,
            }))
        }

        ImprimirDetalleEgreso(newData, parametros.fecha, "");
    }

    const handleCheckCriterio = (e)=>{
        const nuevoCriterio = e.target.value
        reinicializarCriterios(setParametros,parametros,nuevoCriterio,tandas,periodosFiscales)
        cargarNombreCriterio(nuevoCriterio,nombreCriterio)
        hacerfocoEnPrimerInput(`select-${e.target.value}`)
    }

    const cleanUpData = () => { 
        setDatos([]);
    }

    const reinicializarCriterios = (setParametros,parametros,nuevoCriterio,tandas,periodosFiscales)=>{
        setParametros({
            ...parametros,
            criterio : nuevoCriterio,
            id_tanda:tandas[0].id_tanda,
            id_año_fiscal:null,
            fechaDesde:new Date(obtenerFechaDiamenosN(365,'MM/DD/YYYY').diamenosn),
            fechaHasta:new Date(),
            fecha:new Date(),
            mesAño:new Date(),
            año:new Date(),
        })
    }

    const cargarNombreCriterio = (nuevoCriterio,nombreCriterio)=>{
        switch(nuevoCriterio){
            case 'tanda' : nombreCriterio.current = 'Seleccione la tanda:';return
            case 'añofiscal' : nombreCriterio.current = 'Seleccione el año fiscal:';return
            case 'mesaño' : nombreCriterio.current = 'Seleccione el mes y año:';return
            case 'periodo' : nombreCriterio.current = 'Seleccione el período:' ;return
            case 'año' : nombreCriterio.current = 'Seleccione el año:';return
            case 'fecha' : nombreCriterio.current = 'Seleccione la fecha:';return
        }
    }

    const goToIngresoList = ()=>{
        history.push('/ingresos-t');
    }

    const volverAlListadoIngresos = () => {
        setTimeout(() => {
            goToIngresoList();
        }, 1200);
    }

    const handleFPagoOpenDialog = () => { 
        setOpenFPago(true);
    }

    const validarParametros = ()=>{
        if (parametros.destino=="proveedor" && !parametros.id_proveedor){
            alert('Falta seleccionar un proveedor')
            return
        }
        if (parametros.destino=="pastor" && !parametros.id_obrero){
            alert('Falta seleccionar un ministro')
            return
        }
        if (parametros.destino=="iglesia" && !parametros.id_iglesia){
            alert('Falta seleccionar una iglesia')
            return
        }

        if (parametros.fecha == null){
            alert('Falta añadir una fecha')
        }

        if (parametros.monto === 0){
            alert('El monto no puede ser cero')
            return
        }

        if (calcularSaldoPago(parametros.monto,formaPagos) > 0){
            alert('Por favor justifique el monto del ingreso con la forma de pago')
            return
        }

        iniciarGrabarIngreso()
    }

    if (huboError){
        return <Main center>
            <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                <p>Se produjo un error al cargar los datos para esta vista</p>
            </div>
        </Main>
    }

    if (cargandoRegistros){
        return <Main center alinear>
                    <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                        <Spinner className="h-12 w-12" />
                        <span className="cargando font-semibold text-[15px]">Cargando...</span>
                    </div>
                </Main>
    };

    return (  
    <Main center>  
        {!datos.length && <div className={'mr-6 ml-6'}>
            <div className="flex f-col text-large justify-center items-center mb-4">
                <Typography variant="h4">
                    {id_ingreso ? 'Editar' : 'Nuevo'} Ingreso
                </Typography>
            </div>

            <Tabs value="datosE" className="max-w-full mt-6 bg-white tabs-egresos">
                <TabsHeader
                    className="bg-transparent"
                    indicatorProps={{
                        className: "bg-gradient-to-tr from-blue-600 to-blue-400 shadow-none !text-white",
                    }}
                >
                    <Tab 
                        value={"datosE"} 
                        onClick={() => setActiveTab('datosE')}
                        className={`font-semibold ${activeTab==='datosE' ? '!text-white' : ''}`}
                    >
                        Datos del Ingreso
                    </Tab>
                    <Tab 
                        value={"detalleP"} 
                        onClick={() => setActiveTab('detalleP')}
                        className={`font-semibold ${activeTab==='detalleP' ? '!text-white' : ''}`}
                    >
                        Detalle
                    </Tab>
                    <Tab 
                        value={"formaP"} 
                        onClick={() => setActiveTab('formaP')}
                        className={`font-semibold ${activeTab==='formaP' ? '!text-white' : ''}`}
                    >
                        Forma de Pago
                    </Tab>

                </TabsHeader>
                <TabsBody>

                    <TabPanel value={"datosE"}>
                        {/* <div className='flex gap-2'>
                            <Button style={{fontSize:'large',background:'orange',padding:'20px'}} onClick={()=>{copiarEjemplo('fondo_x')}}>CREAR TEST FONDO CENTRAL</Button>

                            <Button style={{fontSize:'large',background:'red',padding:'20px'}} onClick={()=>{copiarEjemplo('diezmo_personal')}}>CREAR TEST DIEZMO PERSONAL</Button>

                            <Button style={{fontSize:'large',background:'blue',padding:'20px'}} onClick={()=>{copiarEjemplo('diezmo_iglesia')}}>CREAR TEST DIEZMO IGLESIA</Button>

                        </div> */}
                            {/* <p className='text-red-700'>Los tests crean un ingreso ficticio para Ezequiel St. con monto aleatorio y descripción = Fecha + hora</p> */}

                            {/*JSON.stringify(parametros)*/}
                            {/* {JSON.stringify(formaPagos)}
                            {JSON.stringify(detallePagos)} */}
                        <Parametros parametros = {parametros} 
                            setParametros={setParametros} 
                            tandas={tandas} 
                            periodosFiscales ={periodosFiscales} 
                            buscarIglesiasPorObrero ={buscarIglesiasPorObrero}
                            centrado={contadorConsulta==0 ? true : false}
                            cajas = {cajas}
                            rubros = {rubros}
                            monedas = {monedas}
                            fondos = {fondos}
                            obreros = {obreros}
                            proveedores = {proveedores}
                            iglesias = {iglesias}
                            tiposMovBanco = {tiposMovBanco}
                            comprEgresos = {comprEgresos}
                            iniciarGrabarIngreso={iniciarGrabarIngreso}
                            IsFetchingData = {IsFetchingData}
                            formaPagos= {formaPagos}
                            id_ingreso = {id_ingreso}
                            setObreros = {setObreros}
                            provincias = {provincias}
                            impDetallEgreso = {impDetallEgreso}
                            backUpObreros = {backUpObreros}
                            setBackUpObreros = {setBackUpObreros}
                            goToEgresoList={goToEgresoList}
                            handleCheckCriterio = {handleCheckCriterio}
                            terminalesUsers = {terminalesUsers}
                            tipoRecibos = {tipoRecibos}
                            history = {history}
                        />
                    </TabPanel>

                    <TabPanel value={"detalleP"}>
                        <DetallePagos 
                            parametros={parametros} 
                            detallePagos={detallePagos}
                            setOpenFPago={setOpenDetallePagos}
                            tiposMovBanco={tiposMovBanco}
                            iglesias={iglesias}
                            rubros={rubros}
                            rubrosDetalle={rubrosDetalle}
                            cleanUpDetallePago={cleanUpDetallePago}
                            listaIglesiasDiezmo={listaIglesiasDiezmo}
                            monto={parametros.monto ?? 0}
                        />

                        <DetallePagoModal
                            setParametros={setParametros}
                            setDetallePagos={setDetallePagos}
                            detallePagos={detallePagos}
                            handleFPagoOpenDialog={handleFPagoOpenDialog}
                            openFPago={openDetallePagos}
                            setOpenFPago={setOpenDetallePagos}
                            iglesias={iglesiasDetalle.length ? iglesiasDetalle : iglesias}
                            tiposMovBanco={tiposMovBanco}
                            rubros={rubros}
                            rubrosDetalle={rubrosDetalle}
                            id_obrero={parametros.id_obrero}
                            listaIglesiasDiezmo={listaIglesiasDiezmo}
                            setListaIglesiasDiezmo={setListaIglesiasDiezmo}
                        />
                    </TabPanel>

                    <TabPanel value={"formaP"}>
                        <FormasPago parametros = {parametros} 
                            formaPagos={formaPagos}
                            setOpenFPago={setOpenFPago}
                            tiposMovBanco={tiposMovBanco}
                            bancos={bancos}
                            monto={parametros.monto ?? 0}
                            cleanUpFormaPago={cleanUpFormaPago}
                        />

                        <FormaPagoModal
                            setFormaPagos={setFormaPagos}
                            formaPagos={formaPagos}
                            handleFPagoOpenDialog={handleFPagoOpenDialog}
                            openFPago={openFPago}
                            setOpenFPago={setOpenFPago}
                            bancos={bancos}
                            bancoCuentas={bancoCuentas}
                            tiposMovBanco={tiposMovBanco}
                            regiones={regiones}
                            id_ingreso={id_ingreso}
                            numeroInterdeposito={numeroInterdeposito}
                        />
                    </TabPanel>
                </TabsBody> 
            </Tabs> 

            {/* <div className='flex justify-center gap-2 mt-1 mb-1'>
                <Button variant="gradient" className="mt-4 w-48 flex justify-center mr-2" onClick={validarParametros}>
                    {IsFetchingData ? <Spinner className="h-4 w-4 mr-2" /> : 'Guardar'}  
                </Button>
                <Button className="mt-4 w-48 flex justify-center bg-gray-900" onClick={goToIngresoList}>
                    Regresar 
                </Button>
            </div>    */}
<div className='flex flex-wrap justify-center items-center gap-4 mt-8 mb-8'>
    {id_ingreso && (
        <Button
            variant="gradient"
            color="indigo"
            className="w-52 h-14 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
            onClick={()=>{
                imprimirRecibo(id_ingreso)}}
            >
                <PrinterIcon className="h-5 w-5" />
                <span className="text-xs text-left leading-tight font-bold">IMPRIMIR RECIBO<br/>PRE-IMPRESO</span>
        </Button>
    )}
    
    {id_ingreso && (
        <Button
            variant="gradient"
            color="teal"
            className="w-52 h-14 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
            onClick={()=>enviarMailRecibo(id_ingreso)}
        >
            {isSendingMail ? (
                <Spinner className="h-5 w-5" />
            ) : (
                <PaperAirplaneIcon className="h-5 w-5" />
            )}
            <span className="text-xs font-bold">ENVIAR POR MAIL</span>
        </Button>
    )}
    
    {id_ingreso && (
        <Button
            variant="gradient"
            color="red"
            className="w-52 h-14 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
            onClick={()=>descargarRecibo(id_ingreso)}
        >
            <ArrowDownTrayIcon className="h-5 w-5" />
            <span className="text-xs font-bold">DESCARGAR PDF</span>
        </Button>
    )}

    {id_ingreso && (
        <Button
            variant="gradient"
            color="orange"
            className="w-52 h-14 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
            onClick={() => anularIngreso(id_ingreso, volverAlListadoIngresos)}
        >
            <XCircleIcon className="h-5 w-5" />
            <span className="text-xs font-bold">ANULAR INGRESO</span>
        </Button>
    )}

    {id_ingreso && (
        <Button
            variant="gradient"
            color="red"
            className="w-52 h-14 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
            onClick={() => eliminarIngreso(id_ingreso, volverAlListadoIngresos)}
        >
            <TrashIcon className="h-5 w-5" />
            <span className="text-xs font-bold">ELIMINAR INGRESO</span>
        </Button>
    )}

    <Button
        variant="gradient"
        color="blue"
        className="w-52 h-14 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
        onClick={validarParametros}
    >
        {IsFetchingData ? (
            <Spinner className="h-5 w-5" />
        ) : (
            <CheckIcon className="h-5 w-5" />
        )}
        <span className="text-sm font-bold">GUARDAR</span>
    </Button>

    <Button
        className="w-52 h-14 flex items-center justify-center gap-2 shadow-md hover:shadow-lg bg-[#212121] hover:bg-black text-white"
        onClick={goToIngresoList}
    >
        <span className="text-sm font-bold">REGRESAR</span>
    </Button>
</div>  
        </div>}

        {esCelular && datos.length > 0 && <TablaMobile registrosAmostrar={datos} cleanUpData={cleanUpData} />}

        {!esCelular && datos.length > 0 && <Tabla
            registrosAmostrar={datos}
            cleanUpData={cleanUpData}
        />}
    </Main>
    )
}

function Parametros({parametros,
                    setParametros,
                    cajas,
                    tandas,
                    buscarIglesiasPorObrero,
                    periodosFiscales,
                    centrado,
                    rubros,
                    tiposMovBanco,
                    comprEgresos,
                    monedas,
                    fondos,
                    obreros,
                    id_ingreso,
                    proveedores,
                    iglesias,
                    history,
                    formaPagos,
                    terminalesUsers,
                    tipoRecibos,
                    IsFetchingData,
                    backUpObreros,
                    setBackUpObreros,
                    setObreros,
                    provincias,
                    handleCheckCriterio,
                    impDetallEgreso,
                    goToEgresoList,
                    iniciarGrabarIngreso,
                    setNombreCriterio}){

    const inputBusquedaRef = useRef()
    const r2 = useRef('null')

    const [buscarDestino,setBuscarDestino] = useState(false)
    const { esCelular} = useContextoGlobal();
    const [cargarManual, setCargarManual] = useState(false);

    useEffect(() => {
        if (id_ingreso && parametros.nro_comprobante) {
            if (!['C', 'X', 'AJ'].includes(parametros.nro_comprobante)) {
                setCargarManual(true);
            } else {
                setCargarManual(false);
            }
        } else if (!id_ingreso && !parametros.nro_comprobante) {
            setParametros(prev => ({...prev, nro_comprobante: ''}));
        }
    }, [id_ingreso, parametros.nro_comprobante]);

    const handleChangeNombre = (e)=>{
        setParametros({...parametros,nombre_destino : e.target.value})
    }

    const handleCheckTipo = (e)=>{
        setParametros({...parametros,tipo : e.target.value,criterio:'tanda'})
    }

    const handleCheckNoAgrupar = (e)=>{
        setParametros({...parametros,no_agrupar : parametros.no_agrupar ? null : e.target.name=="checknoagrupar" ? 1 : e.target.value})
    }

    const handleCheckTotalCaja = (e)=>{
        setParametros({...parametros,total_caja : parametros.total_caja ? false : true})
    }

    const handleCheckTotalDiario = (e)=>{
        setParametros({...parametros,total_diario : parametros.total_diario ? false : true})
    }

    const handleCheckTotalMensual = (e)=>{
        setParametros({...parametros,total_mensual : parametros.total_mensual ? false : true})
    }

    const handleCheckTotalAño = (e)=>{
        setParametros({...parametros,total_año : parametros.total_año ? false : true})
    }

    const handleCrearObreroExterno = async () => {
        const { value: nombre } = await Swal.fire({
            title: 'Crear Ministro Externo',
            input: 'text',
            inputLabel: 'Nombre y Apellido',
            inputPlaceholder: 'Ingrese el nombre...',
            showCancelButton: true,
            confirmButtonText: 'Crear',
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => {
                if (!value) {
                    return '¡Debe ingresar un nombre!'
                }
            }
        });

        if (nombre) {
            try {
                // La API crea el obrero y devuelve el recordset con el id. Aceptamos las
                // variantes de nombre que puede devolver el SP para no fallar por el alias.
                const nombreNormalizado = capitalizarNombre(nombre);
                const res = await Axios.post('/api/tablasgenerales/obreroexterno', { nombre: nombreNormalizado });
                const data = Array.isArray(res.data) ? res.data[0] : res.data;
                const newId = data?.id_obrero ?? data?.id_obrero_resultado ?? data?.id ?? data?.ID_OBRERO;

                if (newId) {
                    Swal.fire({
                        title: 'Éxito',
                        text: 'Ministro externo creado correctamente',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });

                    // externo:true para que quede visible también con el filtro de externos activo
                    const nuevoObrero = { id_obrero: newId, nombre: nombreNormalizado, nom_simple: nombreNormalizado, externo: true };
                    setObreros(prev => [...prev, nuevoObrero]);
                    if (setBackUpObreros) setBackUpObreros(prev => [...prev, nuevoObrero]);
                    setParametros({ ...parametros, id_obrero: newId, id_iglesia: null });
                } else {
                    console.error('Respuesta inesperada al crear obrero externo:', res.data);
                    throw new Error('El servicio no devolvió el id del ministro creado');
                }
            } catch (error) {
                console.error('Error al crear obrero externo:', error);
                // Mostramos el detalle real del backend para poder diagnosticar (antes se ocultaba)
                const detalle = error?.response?.data?.message || error?.response?.data || error?.message;
                Swal.fire('Error', `No se pudo crear el ministro externo.${detalle ? ' ' + detalle : ''}`, 'error');
            }
        }
    };

    const limpiarFiltros = () => { 
        setParametros(initParams);
    }

    const getNombreAportante = ()=> {
        return parametros.id_iglesia
                ? (iglesias.find(i => i.id_iglesia === parametros.id_iglesia)?.nombre ?? '--')
                    : parametros.id_obrero
                        ? (obreros.find(o => o.id_obrero === parametros.id_obrero)?.nombre ?? '--')
                            : parametros.id_proveedor
                                ? (proveedores.find(p => p.id_proveedor === parametros.id_proveedor)?.nombre ?? '--')
                                : ''
    }

    const getLabelAportante = ()=> {
        return parametros.id_iglesia
                ? 'Iglesia'
                    : parametros.id_obrero
                        ? 'Ministro'
                            : parametros.id_proveedor
                                ? 'Proveedor'
                                : ''
    }
    const deleteEgreso = async () => { 
        Swal.fire({
            text: '¿Está seguro de eliminar este egreso?',
            showCancelButton: true,
            confirButtonText: 'Guardar',
            cancelButtonText: 'Cancelar'
        }).then(
            async resultado => {
                if (resultado.value) {
                    try {
                        await Axios.delete('/api/tablasgenerales/ingresos/borrar', { id_ingreso });
                        Swal.fire(`Ingreso eliminado con éxito`,'','info');
                        setTimeout(() => {
                            history.push('/ingresos-t');
                        }, 2000);
                    } catch (error) { 
                        console.log("Error al eliminar el ingreso", error);
                        Swal.fire(`Error al eliminar el ingreso`,'','error')
                    }
                } else console.log("Se canceló la eliminación del ingreso")
            }
        )
    }
    
    return <Card className="mt-4 w-full p-10 mb-10">
                <div className="flex f-col">
                        <Card className="w-full px-6 py-3 mb-3 shadow-md">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                                <div className="flex items-center gap-2 w-full egreso-new">
                                    <div className='w-[220px]'>
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Fecha:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <DatePicker selected={new Date(parametros.fecha)} 
                                                id="select-fecha"
                                                className="select-bg-ui !h-9"
                                                dateFormat="dd/MM/yyyy"
                                                onChange={date => setParametros({...parametros,fecha:date})} 
                                                locale="es"
                                            />                                        
                                        </div>                                        
                                    </div>
                                </div>
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1">
                                            Ministro:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="ml-2 mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%] flex items-center gap-2">
                                            {parametros.id_obrero ? (
                                                <Input
                                                    name="ministro_seleccionado"
                                                    color='black'
                                                    value={capitalizarNombre(obreros.find(item => String(item.id_obrero) === String(parametros.id_obrero))?.nom_simple || '')}
                                                    disabled
                                                    className="!border-t-blue-gray-200 focus:!border-t-gray-900 bg-gray-100 cursor-not-allowed"
                                                    labelProps={{
                                                        className: "before:content-none after:content-none",
                                                    }}
                                                />
                                            ) : (
                                                <SelectorObreroTypeahead
                                                    obreros={obreros}
                                                    value={parametros.id_obrero}
                                                    onChange={(id) => buscarIglesiasPorObrero({ target: { value: id ?? '' } })}
                                                    placeholder="Buscar un ministro..."
                                                />
                                            )}
                                            <div className="flex items-center gap-2 shrink-0">
                                                {/* Permite elegir ministros externos en el selector (mismo criterio que el listado) */}
                                                {!id_ingreso && (
                                                    <label className="flex items-center gap-1 cursor-pointer shrink-0" title="Mostrar sólo ministros externos">
                                                        <Switch
                                                            ripple={false}
                                                            name="isexterno"
                                                            checked={!!parametros.isexterno}
                                                            onChange={(e) => {
                                                                const soloExternos = e.target.checked;
                                                                setParametros({ ...parametros, isexterno: soloExternos, id_obrero: null, id_iglesia: null });
                                                                setObreros(soloExternos ? backUpObreros.filter(o => o?.externo) : backUpObreros);
                                                            }}
                                                        />
                                                        <span className="text-xs font-semibold text-gray-700 whitespace-nowrap">Externos</span>
                                                    </label>
                                                )}
                                                {!parametros.id_obrero && (
                                                    <PlusIcon
                                                        width={22}
                                                        height={22}
                                                        title='Crear ministro externo'
                                                        className='cursor-pointer text-blue-500 hover:text-blue-700'
                                                        onClick={handleCrearObreroExterno}
                                                    />
                                                )}
                                                {parametros.id_obrero && (
                                                    <TrashIcon 
                                                        width={22} 
                                                        height={22} 
                                                        title='Limpiar selección'
                                                        className='cursor-pointer text-red-500 hover:text-red-700' 
                                                        onClick={() => {
                                                            buscarIglesiasPorObrero({target: {value: ""}});
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </Card>

                        <Card className="w-full px-6 py-3 mb-3 shadow-md">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-1">
                                {/* Primera columna */}
                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1">
                                            Tipo Recibo:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Seleccionador 
                                                id='tipo-recibo' 
                                                vector={tipoRecibos} 
                                                valor={parametros.tipo_recibo} 
                                                nombre="Seleccionar" 
                                                onchange={(e)=>setParametros({...parametros,tipo_recibo:e.target.value})} 
                                                claves={{id:'tipo_recibo',nombre:'tipo_recibo'}}
                                                disabled={cargarManual}
                                            />
                                        </div>   
                                    </div> 
                                </div>

                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Usuario alta:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Input
                                                name="nombre" 
                                                color='black'
                                                placeholder="Usuario Alta" 
                                                value={parametros.usuario_alta}
                                                disabled
                                                className=" !border-t-blue-gray-200 focus:!border-t-gray-900 bg-gray-100 cursor-not-allowed"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                        </div>   
                                    </div>
                                </div>

                                <div className="flex items-center gap-2 w-full">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            N° de Comprobante:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <div className="flex flex-col gap-1">
                                                <Input
                                                    name="nro_comprobante" 
                                                    color='black'
                                                    placeholder="N° de Comprobante" 
                                                    value={parametros.nro_comprobante}
                                                    onChange={(event) => setParametros({...parametros,nro_comprobante:event.target.value})}
                                                    maxLength={200}
                                                    disabled={!cargarManual}
                                                    className={`!border-t-blue-gray-200 focus:!border-t-gray-900 ${!cargarManual ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                                    labelProps={{
                                                        className: "before:content-none after:content-none",
                                                    }}
                                                />
                                                <label className="flex items-center gap-2 text-xs mt-1 cursor-pointer w-fit text-gray-500">
                                                    <input type="checkbox" 
                                                        checked={cargarManual}
                                                        onChange={(e) => {
                                                            const isChecked = e.target.checked;
                                                            setCargarManual(isChecked);
                                                            if (isChecked) {
                                                                setParametros({...parametros, nro_comprobante: '', tipo_recibo: ''});
                                                            } else {
                                                                setParametros({...parametros, nro_comprobante: ''});
                                                            }
                                                        }}
                                                    />
                                                    <span className="text-gray-800" style={{ fontSize: 15 }}>Cargar número manualmente</span>
                                                </label>
                                            </div>
                                        </div>   
                                    </div> 
                                </div>

                                <div className="flex items-center gap-2 w-full egreso-new">
                                    <div className="w-[220px]">
                                        <Typography variant="h6" color="blue-gray" className="mt-1 mb-1 lg:mb-0">
                                            Descripción:
                                        </Typography>
                                    </div>
                                    <div className="w-full">
                                        <div className="mt-0 lg:ml-0 xl:ml-0 lg:mt-2 xl:mt-2 w-[95%]">
                                            <Input
                                                name="nombre" 
                                                color='black'
                                                placeholder="Descripción" 
                                                value={parametros.descripcion}
                                                onChange={(event) => setParametros({...parametros, descripcion: event.target.value})}
                                                maxLength={200}
                                                className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                            />
                                        </div>   
                                    </div> 
                                </div>
                                    
                            </div>
                        </Card>

                    {parametros.tipo=='resumen' && <div className={`${esCelular ? '' : 'grid grid-cols-3 justify-left mt-4'}`}>
                            <Typography variant="h5" color="blue-gray" className="mt-1">
                                Totales:
                            </Typography>
                            <div className="col-span-2 ... space-x-2">
                            <Checkbox
                                label="Reporte sin agrupar en meses"
                                ripple={false}
                                name="checknoagrupar" 
                                checked={parametros.no_agrupar}
                                onClick={handleCheckNoAgrupar}
                                className='w-5 h-5'
                                />
                            </div>           
                        </div>
                    }

                    {parametros.tipo=='cronologico' && <div className={`hidden ${esCelular ? '' : 'grid grid-cols-3 justify-left mt-4'}`}>
                            <Typography variant="h5" color="blue-gray" className="mt-1">
                                Totales:
                            </Typography>
                            <div className="col-span-2 ... space-x-2">
                            <Checkbox
                                label="Totales por caja"
                                ripple={false}
                                name="checkcaja" 
                                checked={parametros.total_caja}
                                onClick={handleCheckTotalCaja}
                                className='w-5 h-5'
                            />
                            <Checkbox
                                label="Totales diarios"
                                ripple={false}
                                name="checkcaja" 
                                checked={parametros.total_diario}
                                onClick={handleCheckTotalDiario}
                                className='w-5 h-5'
                            />
                            <Checkbox
                                label="Totales mensuales"
                                ripple={false}
                                name="checkcaja" 
                                checked={parametros.total_mensual}
                                onClick={handleCheckTotalMensual}
                                className='w-5 h-5'
                            />
                            <Checkbox
                                label="Totales por año"
                                ripple={false}
                                name="checkcaja" 
                                checked={parametros.total_año}
                                onClick={handleCheckTotalAño}
                                className='w-5 h-5'
                            />
                            </div>           
                        </div>
                       }


                    <div className={`hidden ${esCelular ? '' : 'grid grid-cols-3 justify-left'}`}>
                        <Typography variant="h5" color="blue-gray" className="mt-1">
                            Reporte:
                        </Typography>
                        <div className="col-span-2 ... space-x-2">
                            <Checkbox
                                label="Resumen"
                                ripple={false}
                                checked={parametros.tipo=='resumen'} 
                                id="tipo-resumen" 
                                name = "tipo" 
                                value="resumen" 
                                onClick={handleCheckTipo}
                                className='w-5 h-5'
                            />
                            <Checkbox
                                label="Cronológico"
                                ripple={false}
                                checked={parametros.tipo=='cronologico'} 
                                id = "tipo-crono" 
                                name="tipo" 
                                value="cronologico" 
                                onClick={handleCheckTipo}
                                className='w-5 h-5'
                            />
                        </div>           
                    </div>
            </div>
        </Card>
}

function FormasPago({
    formaPagos,
    tiposMovBanco,
    bancos,
    setOpenFPago,
    monto,
    cleanUpFormaPago
}){
    
const TABLE_HEAD = ["Forma de Pago", "Monto Bruto", "Valor Cambio", "Valor Neto", ""];

return (
        <Card className="mt-0 w-full p-10 mb-10 relative shadow-none">
            <div className="flex f-col mt-4">
                <div className="flex mt-4 justify-between">
                    <div className='flex gap-1'>
                        <p className='flex font-semibold text-[14px] bg-[#eee]/50 rounded-md mx-2 items-center justify-center my-2 w-[150px]'>
                            Saldo de Pago
                        </p>
                        <span className={`flex justify-right rounded-md items-center font-semibold bg-[#eee]/90 my-2 mx-2 min-w-[60px] px-3
                            ${calcularSaldoPago(monto, formaPagos) === 0 ? 'text-blue-600' : 'text-red-600'}`}>
                            {formatearMontoMoneda(calcularSaldoPago(monto, formaPagos) ?? 0)}
                        </span> 
                    </div>

                  <Button 
                      variant="gradient" 
                      className="mt-2 w-48 flex justify-center" 
                      onClick={() => {
                          if (!monto) 
                              Swal.fire(`Ingrese el monto del ingreso antes de añadir formas de pago`,'','info')  
                          else setOpenFPago(true) 
                      }}
                  >
                      {'Añadir'}
                  </Button>
                </div>

                <table className="w-full table-auto text-left mt-4">
                    <thead>
                    <tr>
                        {TABLE_HEAD.map((head) => (
                        <th
                            key={head}
                            className="border-b border-blue-gray-100 bg-blue-gray-50 p-4 text-center"
                        >
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal leading-none opacity-70"
                            >
                            {head}
                            </Typography>
                        </th>
                        ))}
                    </tr>
                    </thead>
                    <tbody>
                    {formaPagos?.map((data, index) => {
                        const isLast = index === formaPagos.length - 1;
                        const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";
            
                        return (
                        <tr key={index}>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-center break-words whitespace-normal"
                                >
                                    {data.f_pago }
                                    {data.f_pago !== 'Efectivo' && data.tipo_movimiento ? ` - ${tiposMovBanco.find(tipo => Number(tipo.id_tipo_mov_banco) === Number(data.tipo_movimiento))?.nombre}` : ''}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-right"
                                >
                                    {data.m_bruto ? formatearMontoMoneda(Number(data.m_bruto)) : '0.00'}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-right"
                                >
                                    {data.v_cambio_pesos ? formatearMontoMoneda(Number(data.v_cambio_pesos)) : '0.00'}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-right"
                                >
                                    {data.m_neto ? formatearMontoMoneda(Number(data.m_neto)) : '0.00'}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <div className="flex justify-center cursor-pointer hover:text-red-700" onClick={() => cleanUpFormaPago(index)}>
                                    <TrashIcon width={20} />
                                </div>
                            </td>
                        </tr>
                        );
                    })}

                    {!formaPagos?.length && (
                        <tr>
                            <td colSpan={TABLE_HEAD.length + 1} className="text-center p-4">
                                <Typography variant="small" color="blue-gray" className="font-normal">
                                    No hay datos disponibles
                                </Typography>
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </Card>
    )
}

function DetallePagos({
    detallePagos,
    cleanUpDetallePago,
    iglesias,
    setOpenFPago,
    monto,
    parametros,
    listaIglesiasDiezmo,
    rubros,
    rubrosDetalle
}){
    
const TABLE_HEAD = ["Detalle", "Periodo", "Iglesia", "Monto",];

return (
        <Card className="mt-0 w-full p-10 mb-10 relative shadow-none">
            <div className="flex f-col mt-4">
                <div className="flex mt-4 justify-between">
                    <div className='flex gap-1'>
                        <p className='flex font-semibold text-[14px] bg-[#eee]/50 rounded-md mx-2 items-center justify-center my-2 w-[150px]'>
                            Saldo Detalle
                        </p>
                        <span className={`flex justify-right rounded-md items-center font-semibold bg-[#eee]/90 my-2 mx-2 min-w-[60px] px-3
                            text-blue-600`}>
                            {formatearMontoMoneda(monto)}
                        </span> 
                    </div>

                  <Button 
                      variant="gradient" 
                      className="mt-2 w-48 flex justify-center" 
                      onClick={() => {
                          if(!parametros.id_obrero){
                              Swal.fire(`Debe seleccionar un ministro antes de agregar detalle de pago`,'','info');
                              return;
                          }
                          setOpenFPago(true);
                      }}
                      disabled={!parametros.id_obrero}
                  >
                      {'Añadir'}  
                  </Button>
                </div>

                <div className="overflow-x-auto w-full">
                <table className="w-full min-w-max table-auto text-left mt-4">
                    <thead>
                    <tr>
                        {TABLE_HEAD.map((head) => (
                        <th
                            key={head}
                            className="border-b border-blue-gray-100 bg-blue-gray-50 p-4 text-center"
                        >
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal leading-none opacity-70"
                            >
                            {head}
                            </Typography>
                        </th>
                        ))}

                        <th
                            className="border-b border-blue-gray-100 bg-blue-gray-50 p-4"
                        >
                            <Typography
                                variant="small"
                                color="blue-gray"
                                className="font-normal leading-none opacity-70 text-center"
                            >
                            {'Acciones'}
                            </Typography>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {detallePagos?.map((data, index) => {
                        const isLast = index === detallePagos.length - 1;
                        const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";
                        
                        return (
                        <tr key={index}>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-center"
                                >
                                    {data.detalle}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-center"
                                >
                                    {data.periodo} 
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-center"
                                >
                                    {data.iglesia ? data.iglesia : listaIglesiasDiezmo.find(iglesia => Number(iglesia.id_iglesia) === Number(data?.id_iglesia))?.nombre ?? '--'}
                                </Typography>
                            </td>
                            <td className={classes}>
                                <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="font-normal text-right"
                                >
                                    {data.monto ? formatearMontoMoneda(Number(data.monto)) : '0.00'}
                                </Typography>
                            </td>
                            <td className={`${classes} flex justify-center`}>
                                <TrashIcon className="h-5 w-5 text-gray-900 cursor-pointer" onClick={() => cleanUpDetallePago(data.cod_op_ingr_det, data.monto)} />
                            </td>
                        </tr>
                        );
                    })}

                    {!detallePagos?.length && (
                        <tr>
                            <td colSpan={TABLE_HEAD.length + 1} className="text-center p-4">
                                <Typography variant="small" color="blue-gray" className="font-normal">
                                    No hay datos disponibles
                                </Typography>
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
                </div>
            </div>
        </Card>
    )
}

function Seleccionador({
    valor, 
    name, 
    onchange, 
    id, 
    noDefault, 
    nombre, 
    vector, 
    claves, 
    limpiar,
    classancho,
    disabled
  }){
    let clasesSelect = "block appearance-none w-100 select-titulo rounded shadow leading-tight";
    let clasesActivo = "block appearance-none w-full select-titulo rounded shadow leading-tight";

    if (classancho){
        clasesSelect=`block appearance-none ${classancho} select-titulo rounded shadow leading-tight`
    }

    //recordar que un objeto puedo leerlo de 2 formas como vector o como objeto
    // es lo mismo usuario['nombre'] que usuario.nombre
    // aprovecho esta característica para hacer un seleccionador genérico y le paso
    // el nombre de la clave y el texto como un string para referenciarlo en notación vector
    return (            
        <div className="flex flex-col sel select-ui-data w-full">
            <select disabled={disabled} value={valor} name={name? name : ''} className='h-9 font-semibold text-black' onChange ={onchange} id={id? id : null}>
                { noDefault ? null : <option value="*" key="1">{nombre}</option>}
                {vector.map(item=>
                        <option value={item[claves.id]} key={item[claves.id]} className=''>
                            {item[claves.nombre]}
                        </option> 
                    )}
            </select>
            { valor!="*" && limpiar && 
                        <button>
                            <FontAwesomeIcon className="ic-abm"
                                            icon={faWindowClose} 
                                            onClick={limpiar}/>
                        </button>}  
        </div>
        )
        
}   

function generarCodigoUnico() {
    const now = new Date();
    const codigo = 
        now.getFullYear() + // Año
        String(now.getMonth() + 1).padStart(2, '0') + // Mes (con 0 inicial si es necesario)
        String(now.getDate()).padStart(2, '0') + // Día (con 0 inicial si es necesario)
        String(now.getHours()).padStart(2, '0') + // Hora (con 0 inicial si es necesario)
        String(now.getMinutes()).padStart(2, '0') + // Minutos (con 0 inicial si es necesario)
        String(now.getSeconds()).padStart(2, '0') + // Segundos (con 0 inicial si es necesario)
        String(Math.floor(Math.random() * 1000)).padStart(3, '0'); // Número aleatorio de 3 dígitos

    return codigo;
}

function calcularSaldoPago(montoEgreso, formaPagos) {
    const totalPagos = formaPagos?.reduce((total, pago) => {
        return total + (parseFloat(pago.m_neto) || 0);
    }, 0);

    const saldo = montoEgreso - totalPagos;

    return saldo;
}

const FormaPagoModal = ({
    setFormaPagos, 
    formaPagos,
    openFPago, 
    setOpenFPago, 
    handleFPagoOpenDialog,
    bancos,
    bancoCuentas,
    tiposMovBanco,
    id_ingreso,
    regiones,
    numeroInterdeposito
}) => { 

    const [currentFPago, setCurrentFPago] = useState({
        f_pago: 'efectivo',
        v_cambio_pesos: 1,
        id_banco: 30
    })

    const handleCheckFPago = (type, value) => {
        setCurrentFPago({ ...currentFPago, [type]: value })
    }

    const handleAddFPago = async () => {
        if (validateFormaPago([currentFPago])) {
            const cod_op_ingr_pago = generarCodigoUnico();
            const cod_op_ingr = generarCodigoUnico();
            const cod_op_ing_mov_cta = generarCodigoUnico();
            const cod_op_lib_banco = generarCodigoUnico();
            const isDep = currentFPago.f_pago === 'dprecargado';
            const idCtaBancaria = isDep ? (currentFPago.predeposito_seleccionado.id_cuenta_bancaria || 0) : 0;
            const idMovBanco = isDep ? numeroInterdeposito : currentFPago.tipo_movimiento;
            
            let fpago = { ...currentFPago, cod_op_ingr_pago: cod_op_ingr_pago };
            
            let pagos = [];
            let libros = [];
            let movCtas = [];
            
            // Construir objeto Pago
            let pagoObj = {
                id_ingreso,
                id_tipo_moneda: 1, // Pesos por defecto
                monto_bruto: currentFPago.m_bruto,
                valor_cambio: currentFPago.v_cambio_pesos || 1,
                monto_neto: currentFPago.m_neto,
                id_libro_banco: 0,
                f_alta: currentFPago.f_emision || new Date(), 
                cod_op_ingr, 
                cod_op_ingr_pago: cod_op_ingr_pago,
                cod_op_lib_banco: '',
                cod_op_ing_mov_cta: cod_op_ing_mov_cta,
                fecha_ultima_mod: ''
            };

            if (currentFPago.f_pago === 'efectivo') pagos.push(pagoObj);

            if (currentFPago.f_pago !== 'efectivo') {
                if(currentFPago.f_pago === 'dprecargado'){
                        if (!currentFPago.predeposito_seleccionado) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Debe seleccionar un depósito precargado'
                        });
                        return;
                    }

                    if (!currentFPago.predeposito_seleccionado.id_cuenta_bancaria) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Debe seleccionar un depósito precargado'
                        });
                        return;
                    }

                    if (parseFloat(currentFPago.m_bruto) > parseFloat(currentFPago.predeposito_seleccionado.disponible)) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'El monto ingresado supera el disponible del depósito seleccionado'
                        });
                        return;
                    }
                }
                
                // Actualizar referencias en pago
                pagoObj.cod_op_lib_banco = cod_op_lib_banco;
                pagos.push(pagoObj);

                // Determinar valores segun tipo
                const fechaLibro = isDep ? (currentFPago.predeposito_seleccionado.fecha || new Date()) : currentFPago.f_emision;
                const fechaAcre = isDep ? (currentFPago.predeposito_seleccionado.fecha || new Date()) : currentFPago.f_acreditacion;
                const nroComp = isDep ? currentFPago.predeposito_seleccionado.id_mov_cta_dep : currentFPago.n_comprobante;
                const idBanco = isDep ? (currentFPago.predeposito_seleccionado.id_banco_cuenta || 0) : currentFPago.id_banco;
                const sucursal = isDep ? (currentFPago.predeposito_seleccionado.sucursal || '') : '';
                
                const detalleLibro = isDep ? 'Depósito Precargado' : '';

                // Construir objeto Libro Banco (Comun para mbancario y dprecargado)
                let libroObj = {
                    fecha: fechaLibro,
                    ingreso: id_ingreso, 
                    fecha_acreditacion: fechaAcre,
                    id_tipo_moneda: 1,
                    monto_bruto: currentFPago.m_bruto,
                    valor_cambio: currentFPago.v_cambio_pesos || 1,
                    monto_neto: currentFPago.m_neto,
                    numero_comprobante: nroComp,
                    id_tipo_mov_banco: idMovBanco,
                    f_alta: new Date(),
                    id_banco: idBanco,
                    sucursal: sucursal, 
                    id_cuenta_bancaria: idCtaBancaria, 
                    activo: 1,
                    cod_op_lib_banco: cod_op_lib_banco,
                    cod_op_egr_pago: '',
                    cod_op_ingr_pago: cod_op_ingr_pago,
                    detalle: detalleLibro,
                    cod_op_ing_mov_cta: cod_op_ing_mov_cta,
                    fecha_ultima_mod: ''
                };
                libros.push(libroObj);

                if (isDep) {
                    // Construir objeto Movimiento Cuenta (Solo para Depósito precargado por ahora segun logica anterior, 
                    // Asumiremos que mbancario tambien crea un movCtas pero sin id_mov_cta_dep 
                    
                    let movCtaObj = {
                        id_ingreso_mov_cta: 0,
                        id_ingreso_pago: 0,
                        id_mov_cta_dep: currentFPago.predeposito_seleccionado.id_mov_cta_dep,
                        id_libro_banco: 0,
                        monto: currentFPago.m_bruto, 
                        id_cuenta_bancaria: idCtaBancaria || 0,
                        cod_op_ing_mov_cta: cod_op_ing_mov_cta,
                        cod_op_lib_banco: cod_op_lib_banco, 
                        cod_op_ing_pago: cod_op_ingr_pago,
                        activo: 1,
                        fecha_ultima_mod: ''
                    };
                    movCtas.push(movCtaObj);
                } else {
                     let movCtaObj = {
                        id_ingreso_mov_cta: 0,
                        id_ingreso_pago: 0,
                        id_mov_cta_dep: 0, // No hay deposito precargado
                        id_libro_banco: 0,
                        monto: currentFPago.m_neto, 
                        cod_op_ing_mov_cta: cod_op_ing_mov_cta,
                        cod_op_lib_banco: cod_op_lib_banco, 
                        cod_op_ing_pago: cod_op_ingr_pago,
                        activo: 1,
                        fecha_ultima_mod: '',
                        fecha_acreditacion: fechaAcre,
                        id_tipo_moneda: 1,
                        monto_bruto: currentFPago.m_bruto,
                        valor_cambio: currentFPago.v_cambio_pesos || 1,
                        monto_neto: currentFPago.m_neto,
                        numero_comprobante: nroComp || '',
                        id_tipo_mov_banco: idMovBanco || 0,
                        id_banco: idBanco || 0,
                        sucursal: sucursal || '',
                        id_cuenta_bancaria: idCtaBancaria || 0
                    };
                    movCtas.push(movCtaObj);
                }
            }

            try {
                const body = {
                    pagos: pagos,
                    libros: libros,
                    movCtas: movCtas
                };
                
                const { data } = await Axios.post('/api/tablasgenerales/ingresos/pago/cargar/nuevo', body);
                
                if (data) {
                    const nuevoPago = Array.isArray(data) ? data : [data];
                    setFormaPagos(prev => [...prev, {
                        f_pago: nuevoPago[0].forma_pago,
                        m_bruto: nuevoPago[0].monto_bruto,
                        v_cambio_pesos: nuevoPago[0].valor_cambio,
                        m_neto: nuevoPago[0].neto_pesos,
                        cod_op_ingr_pago: nuevoPago[0].cod_op_ingr_pago,
                        cod_op_ingr: currentFPago.f_pago === 'efectivo' ? cod_op_ingr : '',
                        cod_op_ing_mov_cta: currentFPago.f_pago === 'efectivo' ? '' : cod_op_ing_mov_cta,
                        cod_op_lib_banco: currentFPago.f_pago === 'efectivo' ? '' : cod_op_lib_banco,
                        id_mov_cta_dep: isDep ? currentFPago.predeposito_seleccionado.id_mov_cta_dep : 0,
                        id_cuenta_bancaria: idCtaBancaria,
                        id_tipo_mov_banco: idMovBanco,
                        ...(currentFPago.f_pago === 'mbancario' && {
                            fecha_acreditacion: currentFPago.f_acreditacion,
                            id_tipo_moneda: 1,
                            numero_comprobante: currentFPago.n_comprobante || '',
                            id_banco: currentFPago.id_banco || 0,
                            sucursal: '',
                            f_emision: currentFPago.f_emision,
                            n_comprobante: currentFPago.n_comprobante || '',
                            tipo_movimiento: currentFPago.tipo_movimiento || 0
                        })
                    }]);
                } else {
                    // Fallback local si no hay respuesta de datos
                    setFormaPagos([...formaPagos, { ...fpago }]);
                }

                handleCancelFpago();

            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al guardar la forma de pago'
                });
            }

        } else {
            Swal.fire({
                icon: 'error',
                title: `<p>Por favor, complete todos los campos al agregar una forma de pago</p>`,
                showCancelButton: true,
            });
        }
    }

    const handleCancelFpago = () => {
        setCurrentFPago({
            f_pago: 'efectivo',
            v_cambio_pesos: 1
        });
        setOpenFPago(false);
    }

    return (
        <>
            <Dialog open={openFPago} handler={handleFPagoOpenDialog} size={currentFPago.f_pago === 'dprecargado' ? 'lg' : 'md'}>
                <DialogHeader>Añadir Forma de Pago</DialogHeader>
                <DialogBody className="xl:p-10 overflow-y-auto max-h-[calc(100vh-200px)]">
                    <div className="flex flex-col mt-[-20px] lg:mt-[-40px]">
                        <div className={`grid ${currentFPago.f_pago === 'dprecargado' ? 'grid-cols-1 md:grid-cols-3' : 'grid-cols-1'} gap-3`}>
                            <div className="w-full flex flex-col">
                                <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                    Monto Bruto
                                </Typography>
                                <Input
                                    onChange={(e) => { 
                                        setCurrentFPago({ 
                                            ...currentFPago, 
                                            m_bruto: e.target.value,
                                            m_neto: (e.target.value / (currentFPago.v_cambio_pesos || 1)).toFixed(2)
                                        }) 
                                    }} 
                                    onBlur={() => {
                                        setCurrentFPago(fp => ({
                                            ...fp,
                                            m_bruto: fp.m_bruto !== undefined && fp.m_bruto !== '' 
                                                ? Number(fp.m_bruto).toFixed(2) 
                                                : fp.m_bruto
                                        }))
                                    }}
                                    name="Monto Bruto" 
                                    type='number'
                                    color='black'
                                    placeholder="Monto Bruto" 
                                    value={currentFPago.m_bruto}
                                    maxLength={200}
                                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                    labelProps={{
                                        className: "before:content-none after:content-none",
                                    }}
                                />
                            </div>
                            <div className="w-full flex flex-col">
                                <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                    Valor de Cambio
                                </Typography>
                                <Input
                                    onChange={(e) => { 
                                        setCurrentFPago({ 
                                            ...currentFPago, 
                                            v_cambio_pesos: e.target.value,
                                            m_neto: (currentFPago.m_bruto / (e.target.value || 1)).toFixed(2)
                                        }) 
                                    }} 
                                    onBlur={() => {
                                        setCurrentFPago(fp => ({
                                            ...fp,
                                            v_cambio_pesos: fp.v_cambio_pesos !== undefined && fp.v_cambio_pesos !== '' 
                                                ? Number(fp.v_cambio_pesos).toFixed(2) 
                                                : fp.v_cambio_pesos
                                        }))
                                    }}
                                    name="nombre" 
                                    type='number'
                                    color='black'
                                    value={currentFPago.v_cambio_pesos}
                                    placeholder="Valor de Cambio Pesos" 
                                    maxLength={200}
                                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                    labelProps={{
                                        className: "before:content-none after:content-none",
                                    }}
                                />
                            </div>
                            <div className="w-full flex flex-col">
                                <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                    Monto Neto
                                </Typography>
                                <Input
                                    onChange={(e) => setCurrentFPago({ ...currentFPago, m_neto: e.target.value })} 
                                    name="Monto Neto" 
                                    type='number'
                                    color='black'
                                    value={currentFPago.m_neto}
                                    placeholder="Monto Neto" 
                                    maxLength={200}
                                    className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                    labelProps={{
                                        className: "before:content-none after:content-none",
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col mt-4">
                            <Typography variant="h5" color="blue-gray" className="mt-2">
                                Tipo de Pago
                            </Typography>
                            <div className="flex flex-col md:flex-row gap-2 w-full mt-1">
                                <Checkbox
                                    label="Efectivo"
                                    ripple={false}
                                    checked={currentFPago.f_pago == 'efectivo'} 
                                    onClick={() => handleCheckFPago('f_pago', 'efectivo')}
                                    className='w-5 h-5'
                                />
                                <Checkbox
                                    label="Movimiento Bancario (che, dep)"
                                    ripple={false}
                                    checked={currentFPago.f_pago == 'mbancario'} 
                                    onClick={() => handleCheckFPago('f_pago', 'mbancario')}
                                    className='w-5 h-5'
                                />
                                <Checkbox
                                    label="Depósito precargado"
                                    ripple={false}
                                    checked={currentFPago.f_pago == 'dprecargado'} 
                                    onClick={() => handleCheckFPago('f_pago', 'dprecargado')}
                                    className='w-5 h-5'
                                />
                            </div>
                        </div>
                        
                        {currentFPago.f_pago === 'mbancario' && (
                            <div className='flex flex-col'>
                                <Typography variant="h6" color="blue-gray" className="mt-2">
                                    Libro Banco
                                </Typography>
                                <div className="flex flex-row gap-3">
                                    <div className="w-1/2 flex flex-col">
                                        <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                            Tipo Movimiento
                                        </Typography>
                                        <Seleccionador id='select-banco' vector={tiposMovBanco} valor={currentFPago.tipo_movimiento} nombre="Todos" onchange={(e)=>setCurrentFPago({...currentFPago,tipo_movimiento:e.target.value})} claves={{id:'id_tipo_mov_banco',nombre:'nombre'}}/>
                                    </div>
                                    <div className="w-1/2 flex flex-col">
                                        <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                            Nro Comprobante
                                        </Typography>
                                        <Input
                                            onChange={(e) => setCurrentFPago({ ...currentFPago, n_comprobante: e.target.value })} 
                                            name="nombre" 
                                            color='black'
                                            placeholder="Nro Comprobante" 
                                            maxLength={200}
                                            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                            labelProps={{
                                                className: "before:content-none after:content-none",
                                            }}
                                        />
                                    </div>
                                </div>  

                                <div className="flex flex-row gap-3 mt-4">
                                    <div className="flex flex-col w-1/2">
                                        <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                            Fecha de Emisión
                                        </Typography>
                                        <DatePicker selected={currentFPago.f_emision} 
                                            id="select-fecha"
                                            className="select-bg-ui !h-9"
                                            onChange={date => setCurrentFPago({...currentFPago,f_emision:date})} 
                                            locale="es"
                                        /> 
                                    </div>

                                    <div className="flex flex-col w-1/2">
                                        <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                            Fecha de Acreditación
                                        </Typography>
                                        <DatePicker selected={currentFPago.f_acreditacion} 
                                            id="select-fecha"
                                            className="select-bg-ui !h-9"
                                            onChange={date => setCurrentFPago({...currentFPago,f_acreditacion:date})} 
                                            locale="es"
                                        /> 
                                    </div>
                                </div>

                                <div className="flex flex-col mt-4">
                                    <Typography variant="h7" color="blue-gray" className="mt-2 font-semibold">
                                        Banco
                                    </Typography>
                                    <Seleccionador id='select-banco' vector={bancos} valor={currentFPago.id_banco} nombre="Todos" onchange={(e)=>setCurrentFPago({...currentFPago,id_banco:e.target.value})} claves={{id:'id_banco',nombre:'nombre'}}/>
                                </div>
                            </div>
                        )}

                        {currentFPago.f_pago === 'dprecargado' && (
                            <DepositoPrecargado 
                                bancos={bancos}
                                bancoCuentas={bancoCuentas}
                                regiones={regiones}
                                currentFPago={currentFPago}
                                setCurrentFPago={setCurrentFPago}
                            />
                        )}
                    </div>
                </DialogBody>
                <DialogFooter className="space-x-2">
                    <Button 
                        variant="gradient" 
                        color="blue" 
                        onClick={handleAddFPago}
                    >
                        Agregar
                    </Button>

                    <Button variant="text" color="blue-gray" onClick={handleCancelFpago}>
                        Cancelar
                    </Button>
                </DialogFooter>
            </Dialog>
        </>
    )
}

const DetallePagoModal = ({
    setParametros,
    setDetallePagos, 
    detallePagos,
    openFPago, 
    setOpenFPago, 
    handleFPagoOpenDialog,
    iglesias,
    rubros,
    rubrosDetalle,
    listaIglesiasDiezmo,
    setListaIglesiasDiezmo,
    id_obrero
}) => { 

    const aniosListado = Array.from({length: 50}, (_, i) => new Date().getFullYear() - i + 1).map(y => ({id: y, nombre: y.toString()}));

    // estado del formulario de detalle
    const [detalleForm, setDetalleForm] = useState({
        id_rubro: '',
        id_iglesia: '',
        monto: '',
        periodos: [{ id: Date.now(), anio: new Date().getFullYear(), mes: new Date().getMonth() + 1 }],
        diezmo_personal: false
    });

    const [cargandoIglesias, setCargandoIglesias] = useState(false);

    const iglesiaSel = listaIglesiasDiezmo?.find(i => Number(i.id_iglesia) === Number(detalleForm.id_iglesia));

    const mesesListado = [
        { id:1, nombre:'Enero' },{ id:2, nombre:'Febrero' },{ id:3, nombre:'Marzo' },{ id:4, nombre:'Abril' },
        { id:5, nombre:'Mayo' },{ id:6, nombre:'Junio' },{ id:7, nombre:'Julio' },{ id:8, nombre:'Agosto' },
        { id:9, nombre:'Septiembre' },{ id:10, nombre:'Octubre' },{ id:11, nombre:'Noviembre' },{ id:12, nombre:'Diciembre' }
    ];

    const isDiezmo = () => {
        const rubroSel = rubrosDetalle.find(r => Number(r.id_rubro_ingreso) === Number(detalleForm.id_rubro));
        return rubroSel ? /Diezmos/i.test(rubroSel.nombre) : false;
    };

    // cargar iglesias específicas sólo si es diezmo y hay obrero/rubro
    useEffect(()=>{
        const loadIglesiasDetalle = async () => {
            if(isDiezmo() && id_obrero && detalleForm.id_rubro){
                setCargandoIglesias(true);
                try{
                    const id_region = rubrosDetalle.find(r => Number(r.id_rubro_ingreso) === Number(detalleForm.id_rubro))?.id_region;
                    const resp = await Axios.get(`/api/tablasgenerales/iglesias/pago/detalle/${id_obrero}/${id_region}`);
                    setListaIglesiasDiezmo(resp.data[0] || []);
                }catch(err){
                    setListaIglesiasDiezmo([]);
                }finally{
                    setCargandoIglesias(false);
                }
            }
        };
        loadIglesiasDetalle();
    },[detalleForm.id_rubro,id_obrero]);

    const handleSelectMes = (numMes, pIndex) => {
        setDetalleForm(f => {
            const newPeriodos = [...f.periodos];
            newPeriodos[pIndex].mes = Number(numMes);
            return { ...f, periodos: newPeriodos };
        });
    };

    const resetForm = () => {
        setDetalleForm({ id_rubro:'', id_iglesia:'', monto:'', periodos:[{ id: Date.now(), anio:new Date().getFullYear(), mes: new Date().getMonth() + 1 }], diezmo_personal:false });
        setOpenFPago(false);
    };

    const validarDetalle = () => {
        if(!detalleForm.id_rubro) return 'Seleccione un rubro';
        if(!detalleForm.monto) return 'Ingrese un monto';
        if(isDiezmo()){
            if(!id_obrero) return 'Debe seleccionar un ministro';
            if(!detalleForm.id_iglesia && !detalleForm.diezmo_personal) return 'Seleccione una iglesia';
            if(detalleForm.periodos.length === 0) return 'Seleccione al menos un periodo';
            if(detalleForm.periodos.some(p => !p.anio || !p.mes)) return 'Complete el año y mes para todos los periodos';
        }
        return null;
    };

    const handleAddDetalle = async () => {
        const error = validarDetalle();
        if(error){
            Swal.fire(error,'','info');
            return;
        }
        const rubroObj = rubrosDetalle.find(r=>Number(r.id_rubro_ingreso)===Number(detalleForm.id_rubro));
        const iglesiaObj = listaIglesiasDiezmo.find(i=>Number(i.id_iglesia)===Number(detalleForm.id_iglesia));
        const cod_op_ingr_det_per = generarCodigoUnico();
        let montoTotal = 0;
        let nuevos = [];

        if(isDiezmo()){
            detalleForm.periodos.forEach(p => {
                const periodoValor = `${p.anio}-${String(p.mes).padStart(2,'0')}`;
                nuevos.push({
                    cod_op_ingr: generarCodigoUnico(),
                    cod_op_ingr_det: generarCodigoUnico(),
                    cod_op_ingr_det_per,
                    id_rubro: rubroObj.id_rubro_ingreso,
                    detalle: rubroObj?.nombre || 'Rubro',
                    periodo: periodoValor,
                    id_iglesia: iglesiaObj?.id_iglesia || null,
                    monto: Number(detalleForm.monto),
                    diezmo_personal: detalleForm.diezmo_personal ? 1 : 0,
                    isNew: true
                });
            });
        }else{
            nuevos = [{
                cod_op_ingr: generarCodigoUnico(),
                cod_op_ingr_det: generarCodigoUnico(),
                id_rubro: rubroObj.id_rubro_ingreso,
                detalle: rubroObj?.nombre || 'Rubro',
                periodo: '--',
                id_iglesia: null,
                monto: Number(detalleForm.monto),
                diezmo_personal: 0,
                isNew: true
            }];
        }

        montoTotal += Number(detalleForm.monto);
        const respCarga = await Axios.post('/api/tablasgenerales/ingresos/detalle/cargar/nuevo', nuevos);
        setDetallePagos([...detallePagos, { 
            ...respCarga.data[0],
            cod_op_ingr_det_per,
            id_rubro: rubroObj.id_rubro_ingreso,
            id_iglesia: iglesiaObj?.id_iglesia || null,
            diezmo_personal: detalleForm.diezmo_personal ? 1 : 0
        }]);
        setParametros(p => ({ ...p, monto: Number(p.monto) + montoTotal }));
        resetForm();
    };

    return (
        <Dialog open={openFPago} handler={()=>{}} size="md" className="max-w-[780px]">
            <DialogHeader>Añadir Detalle de Pago</DialogHeader>
            <DialogBody className="xl:p-8 overflow-y-auto max-h-[calc(100vh-200px)]">
                <div className="flex flex-col gap-6">
                    <div className="flex flex-col w-full">
                        <Typography variant="h7" color="blue-gray" className="font-semibold mb-2">Rubro</Typography>
                        <Seleccionador id='select-rubro-detalle' vector={rubrosDetalle} valor={detalleForm.id_rubro} nombre="Seleccionar" onchange={(e)=>setDetalleForm({...detalleForm,id_rubro:e.target.value})} claves={{id:'id_rubro_ingreso',nombre:'nombre'}}/>
                    </div>

                    {isDiezmo() && (
                        <>
                            <div className="flex flex-col w-full">
                                <Typography variant="h7" color="blue-gray" className="font-semibold mb-2">Iglesia</Typography>
                                <div className="flex flex-row gap-4 items-center">
                                    <div className="w-full">
                                        {cargandoIglesias ? <Spinner className="h-6 w-6" /> : (
                                            <Seleccionador disabled={detalleForm.diezmo_personal} id='select-iglesia-detalle' vector={listaIglesiasDiezmo} valor={detalleForm.id_iglesia || '*'} nombre="Seleccionar" onchange={(e)=>setDetalleForm({...detalleForm,id_iglesia:e.target.value})} claves={{id:'id_iglesia',nombre:'nombre'}}/>
                                        )}
                                    </div>
                                    <div className="flex items-center gap-1 shrink-0">
                                        <Checkbox
                                            ripple={false}
                                            checked={detalleForm.diezmo_personal} 
                                            onClick={() => {
                                                const newVal = !detalleForm.diezmo_personal;
                                                setDetalleForm({ ...detalleForm, diezmo_personal: newVal, id_iglesia: newVal ? '' : detalleForm.id_iglesia });
                                            }}
                                            className='w-5 h-5'
                                        />
                                        <Typography variant="small" color="blue-gray" className="font-medium whitespace-nowrap">Diezmo personal</Typography>
                                    </div>
                                </div>
                                {detalleForm.id_iglesia && iglesiaSel && (
                                    <div className="mt-2 p-3 bg-blue-50/50 border border-blue-100 rounded-lg shadow-sm">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2 text-xs">
                                            <div className="flex gap-1 items-start">
                                                <span className="font-bold text-blue-gray-900 min-w-[65px]">Encargado:</span>
                                                <span className="text-gray-700 truncate" title={iglesiaSel.encargado}>{iglesiaSel.encargado || 'N/A'}</span>
                                            </div>
                                            <div className="flex gap-1 items-start">
                                                <span className="font-bold text-blue-gray-900 min-w-[65px]">Tipo:</span>
                                                <span className="text-gray-700">{iglesiaSel.tipo_iglesia || 'N/A'}</span>
                                            </div>
                                            <div className="flex gap-1 items-start">
                                                <span className="font-bold text-blue-gray-900 min-w-[65px]">Dirección:</span>
                                                <span className="text-gray-700 truncate" title={iglesiaSel.direccion}>{iglesiaSel.direccion || 'N/A'}</span>
                                            </div>
                                            <div className="flex gap-1 items-start">
                                                <span className="font-bold text-blue-gray-900 min-w-[65px]">Localidad:</span>
                                                <span className="text-gray-700 truncate" title={iglesiaSel.localidad}>{iglesiaSel.localidad || 'N/A'}</span>
                                            </div>
                                            <div className="flex gap-1 items-start">
                                                <span className="font-bold text-blue-gray-900 min-w-[65px]">Provincia:</span>
                                                <span className="text-gray-700">{iglesiaSel.provincia || 'N/A'}</span>
                                            </div>
                                            <div className="flex gap-1 items-start">
                                                <span className="font-bold text-blue-gray-900 min-w-[65px]">Región:</span>
                                                <span className="text-gray-700">{iglesiaSel.region || 'N/A'}</span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="flex flex-col gap-4 w-full">
                                <div className="flex justify-between items-center">
                                    <Typography variant="h7" color="blue-gray" className="font-semibold">Periodos</Typography>
                                    <Button size="sm" variant="text" className="flex items-center gap-2" onClick={() => setDetalleForm(f => ({ ...f, periodos: [...f.periodos, { id: Date.now(), anio: new Date().getFullYear(), mes: new Date().getMonth() + 1 }] }))}>
                                        <PlusIcon className="h-4 w-4"/> Añadir Periodo
                                    </Button>
                                </div>
                                {detalleForm.periodos.map((periodo, pIndex) => (
                                    <div key={periodo.id} className="border border-blue-gray-100 p-4 rounded-lg relative flex flex-col md:flex-row gap-4 items-center">
                                        {detalleForm.periodos.length > 1 && (
                                            <button className="absolute top-2 right-2 text-red-500 hover:text-red-700" onClick={() => {
                                                const newPeriodos = [...detalleForm.periodos];
                                                newPeriodos.splice(pIndex, 1);
                                                setDetalleForm({...detalleForm, periodos: newPeriodos});
                                            }}>
                                                <TrashIcon className="h-5 w-5" />
                                            </button>
                                        )}
                                        <div className="flex flex-col w-full md:w-1/2 mt-2 md:mt-0">
                                            <Typography variant="small" color="blue-gray" className="font-medium mb-1">Año</Typography>
                                            <Seleccionador id={`select-anio-${periodo.id}`} vector={aniosListado} valor={periodo.anio} nombre="Seleccionar" onchange={e=>{
                                                const newPeriodos = [...detalleForm.periodos];
                                                newPeriodos[pIndex].anio = e.target.value;
                                                setDetalleForm({...detalleForm, periodos: newPeriodos});
                                            }} claves={{id:'id',nombre:'nombre'}}/>
                                        </div>
                                        <div className="flex flex-col w-full md:w-1/2 mt-2 md:mt-0">
                                            <Typography variant="small" color="blue-gray" className="font-medium mb-1">Mes</Typography>
                                            <Seleccionador id={`select-mes-${periodo.id}`} vector={mesesListado} valor={periodo.mes} nombre="Seleccionar" onchange={e=>{
                                                handleSelectMes(e.target.value, pIndex);
                                            }} claves={{id:'id',nombre:'nombre'}}/>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}

                    <div className="flex flex-col w-full">
                        <Typography variant="h7" color="blue-gray" className="font-semibold mb-2">Monto</Typography>
                        <Input type='number' value={detalleForm.monto} onChange={(e)=>setDetalleForm({...detalleForm,monto:e.target.value})} placeholder="Monto" className=" !border-t-blue-gray-200 focus:!border-t-gray-900" />
                    </div>
                </div>
            </DialogBody>
            <DialogFooter className="space-x-2">
                <Button variant="gradient" color="blue" onClick={handleAddDetalle}>Agregar</Button>
                <Button variant="text" color="blue-gray" onClick={resetForm}>Cancelar</Button>
            </DialogFooter>
        </Dialog>
    );
}

const validateFormaPago = (formaPagos) => { 
    let isValid = true;
    formaPagos.forEach((fpago) => {
        if (!fpago.f_pago || !fpago.m_bruto || !fpago.v_cambio_pesos || !fpago.m_neto || (fpago.f_pago === 'mbancario' && (!fpago.tipo_movimiento || !fpago.id_banco))) {
            isValid = false;
        }
    });
    return isValid;
}